/**
 * Setara mega menu — standalone navigation with animated panels.
 */
(function () {
  const nav = document.querySelector('[data-setara-mega-nav]');
  if (!nav) return;

  const items = nav.querySelectorAll('[data-setara-mega-item]');
  let activeItem = null;
  let closeTimer = null;
  const CLOSE_DELAY = 450;
  const PANEL_SETTLE_MS = 580;
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const headerWrapper = nav.closest('.header-wrapper');

  const cancelClose = () => {
    clearTimeout(closeTimer);
  };

  const scheduleClose = () => {
    cancelClose();
    closeTimer = setTimeout(closeAll, CLOSE_DELAY);
  };

  const resetPanelSettle = (item) => {
    item.classList.remove('is-panel-settled');
    if (item._settleTimer) {
      clearTimeout(item._settleTimer);
      item._settleTimer = null;
    }
  };

  const schedulePanelSettle = (item) => {
    resetPanelSettle(item);

    const panelBody = item.querySelector('.setara-mega-nav__panel-body');
    if (!panelBody || panelBody.classList.contains('setara-mega-nav__panel-body--simple')) {
      return;
    }

    if (prefersReducedMotion) {
      item.classList.add('is-panel-settled');
      return;
    }

    item._settleTimer = setTimeout(() => {
      if (item.classList.contains('is-open')) {
        item.classList.add('is-panel-settled');
      }
    }, PANEL_SETTLE_MS);
  };

  const closeAll = () => {
    items.forEach((item) => {
      const trigger = item.querySelector('.setara-mega-nav__trigger');
      const panel = item.querySelector('[data-setara-mega-panel]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (panel) panel.setAttribute('aria-hidden', 'true');
      item.classList.remove('is-open');
      resetPanelSettle(item);
    });
    activeItem = null;
    nav.classList.remove('is-active');
    nav.classList.remove('is-active--mega');
  };

  const openItem = (item) => {
    if (activeItem === item) return;
    closeAll();

    const trigger = item.querySelector('.setara-mega-nav__trigger');
    const panel = item.querySelector('[data-setara-mega-panel]');
    if (!trigger || !panel) return;

    trigger.setAttribute('aria-expanded', 'true');
    panel.setAttribute('aria-hidden', 'false');

    // Ensure closed styles paint before opening so the entrance transition runs.
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        item.classList.add('is-open');
        activeItem = item;
        nav.classList.add('is-active');

        if (
          item.dataset.panelType === 'mega' ||
          item.dataset.panelType === 'image-mega' ||
          item.dataset.panelType === 'split-mega'
        ) {
          nav.classList.add('is-active--mega');
        }

        schedulePanelSettle(item);
      });
    });
  };

  items.forEach((item) => {
    const trigger = item.querySelector('.setara-mega-nav__trigger');
    const panel = item.querySelector('[data-setara-mega-panel]');
    if (!trigger || !panel) return;

    const panelType = item.dataset.panelType;
    const isFullPanel =
      panelType === 'mega' || panelType === 'image-mega' || panelType === 'split-mega';

    item.addEventListener('mouseenter', () => {
      cancelClose();
      openItem(item);
    });

    // Narrow <li> boxes do not cover the panel — only close on item leave for compact dropdowns.
    if (!isFullPanel) {
      item.addEventListener('mouseleave', scheduleClose);
    }

    panel.addEventListener('mouseenter', cancelClose);
    panel.addEventListener('mouseleave', scheduleClose);
    trigger.addEventListener('mouseenter', cancelClose);

    trigger.addEventListener('focus', () => openItem(item));

    trigger.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        closeAll();
        trigger.blur();
      }
    });
  });

  nav.querySelectorAll('.setara-mega-nav__panel-backdrop').forEach((backdrop) => {
    backdrop.addEventListener('mouseenter', cancelClose);
    backdrop.addEventListener('mouseleave', scheduleClose);
  });

  if (headerWrapper) {
    headerWrapper.addEventListener('mouseleave', scheduleClose);
  }

  nav.querySelectorAll('[data-setara-mega-close]').forEach((el) => {
    el.addEventListener('click', closeAll);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll();
  });

  document.addEventListener('click', (e) => {
    if (!nav.contains(e.target)) closeAll();
  });

  document.addEventListener('setara:mega-nav:close', closeAll);
})();
